module.exports = __webpack_public_path__ + "static/media/india-flag-large.8876e2a3.png";